import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Select2 } from 'libs/form';
import { prepareLangKey } from 'libs/common';
import { Content } from './tarifficator-selector.styled';

export const TarifficatorSelector = (props) => {
  const { onChange, value, items } = props;
  const { t, i18n } = useTranslation();

  /**
   * get tarifficator title
   */
  const getTitle = useCallback(
    (tarifficator) => {
      // check path
      let test = 'tarifficators.' + prepareLangKey(tarifficator.path);
      if (i18n.exists(test)) {
        return t(test);
      }

      // check template
      test = 'tarifficatorTpls.' + prepareLangKey(tarifficator.template);
      if (i18n.exists(test)) {
        return t(test) + ' (' + tarifficator.path + ')';
      }
      return tarifficator.path;
    },
    [t],
  );

  /**
   * change
   * @param {*} event
   */
  const change = (event) => {
    onChange(event.target.value);
  };

  const itemsList = items.map((el) => ({ value: el.path, name: getTitle(el) }));

  return (
    <Content>
      <Select2 onChange={change} value={value.path} fullWidth={false} items={itemsList} />
      {/* <SimpleSelect onChange={change} value={value.path}>
        {itemsEl}
      </SimpleSelect> */}
    </Content>
  );
};
